// Widget component registry with dynamic imports
const widgetComponents = {
  faqs_widget: () => import("../widgets/FAQs"),
  post_slider:() => import("../widgets/PostSlider"),
  single_post: () => import("../widgets/SinglePost"),
  header_widget: () => import("../widgets/Header"),
  map_location_widget: () => import("../widgets/MapLocation"),
  programs_slider_widget: () => import("../widgets/ProgramSlider"),
  gallery_slider_widget: () => import("../widgets/GallerySlider"),
  grid_programs_widget: () => import("../widgets/GridPrograms"),
  founder_widget: () => import("../widgets/Founder"),
  

};


export default widgetComponents